const imgs = [
  // {
  //   link: 'https://i.ibb.co/rvFdmJD/architecture-3488306-1280.jpg',
  //   alter: 'picture',
  // },
  // { link: 'https://i.ibb.co/Y2xrHLH/3.webp', alter: 'picture' },
  // { link: 'https://i.ibb.co/VWcrbD8/1.webp', alter: 'picture' },
  // { link: 'https://i.ibb.co/P4d7V8m/2.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/6rVPZr3/5.webp', alter: 'picture' },
  // { link: 'https://i.ibb.co/TkBDSpF/4.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/Y2xrHLH/3.webp', alter: 'picture' },
  // { link: 'https://i.ibb.co/frSWqFt/1.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/92P6MbQ/2.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/MMpS2b0/3.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/BwqVkc3/4.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/C50pXcc/5.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/myWh57t/6.jpg', alter: 'picture' },
  // { link: 'https://i.ibb.co/mvPnVBn/7.jpg', alter: 'picture' },
  {
    link: 'https://i.ibb.co/2gvGm5k/5.jpg',
    alter: 'picture',
    year: '2023',
    size: '100 x 100 cm x 2',
    status: 'Sold',
  },
  {
    link: 'https://i.ibb.co/MMpS2b0/3.jpg',
    alter: 'picture',
    year: '2023',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/frSWqFt/1.jpg',
    alter: 'picture',
    year: '2022',
    size: '95 x 75 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/X8cxY4s/3.jpg',
    alter: 'picture',
    year: '2022',
    size: '65 x 45 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/djLL5zf/4.jpg',
    alter: 'picture',
    year: '2020',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/0r7m6mc/6.jpg',
    alter: 'picture',
    year: '2021',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/gv9Xy3T/7.jpg',
    alter: 'picture',
    year: '2023',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/2Pm8B3Y/8.jpg',
    alter: 'picture',
    year: '2023',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/GpfF45n/9.jpg',
    alter: 'picture',
    year: '2022',
    size: '85 x 65 cm',
    status: 'For sale',
  },
  {
    link: 'https://i.ibb.co/qythH57/10.jpg',
    alter: 'picture',
    year: '2023',
    size: '85 x 65 cm',
    status: 'For sale',
  },
];

export default imgs;
